export default __webpack_public_path__ + "static/media/wave-haikei.c9dc796f.svg";